import { useCallback } from 'react';

import { IconSize, IconWrapper, ResultsIcon, Tooltip, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { getStatisticsPreviewPath } from '../../../routes';
import { statisticsTranslationKeys } from '../../../translations';

type ResultsIconActionProps = {
   readonly statisticsId: number;
};

export const ResultsIconAction = (props: ResultsIconActionProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(true);
   const goToStatisticsList = useCallback(
      (): void =>
         push(getStatisticsPreviewPath(props.statisticsId), {
            label: statisticsTranslationKeys.preview.goToStatisticsList,
         }),
      [props.statisticsId, push]
   );

   return (
      <Tooltip content={statisticsTranslationKeys.orderTable.actions.preview} testId={'previewStatistics'}>
         <IconWrapper onClick={goToStatisticsList} testId={'resultsIcon'} size={IconSize.NORMAL}>
            <ResultsIcon />
         </IconWrapper>
      </Tooltip>
   );
};
